<template>
  <section class="py-6 md:py-15">
    <h2 class="section-heading mb-8 text-center">
      Where Fun Activities Meet Our Wellness
    </h2>
    <template v-if="!isLoading">
      <Swiper
        :modules="[SwiperNavigation]"
        :slides-per-view="1"
        :centered-slides="true"
        :loop="true"
        :breakpoints="{
          '640': {
            slidesPerView: 1,
            spaceBetween: 20
          },
          '768': {
            slidesPerView: 2,
            spaceBetween: 40
          },
          '1024': {
            slidesPerView: 2,
            spaceBetween: 40
          }
        }"
        :space-between="20"
        @swiper="onSwiper"
      >
        <!-- CUSTOM NAVIGATION -->
        <div
          class="hidden sm:flex justify-between md:justify-center absolute md:top-[30%] xl:top-[33%] w-full z-10 p-4 sm:p-0 gap-x-[60%]"
        >
          <button @click.stop="slider.slidePrev()">
            <nuxt-icon name="icon-park_arrow-left" filled />
          </button>
          <button @click.stop="slider.slideNext()">
            <nuxt-icon name="icon-park_arrow-right" filled />
          </button>
        </div>

        <SwiperSlide
          v-for="(slide, index) in getActivities"
          :key="index"
          v-slot="{ isActive, isPrev, isNext }"
          class="md:py-8 px-[10px] carousel-opacity relative"
        >
          <div class="relative">
            <NuxtImg
              format="webp"
              srcset=""
              :src="slide.icon?.data?.attributes?.url"
              :alt="slide.title"
              :title="slide.title"
              class="mx-auto w-full"
              :class="isActive ? '' : 'opacity-50'"
              loading="lazy"
            />
            <h3
              v-if="!isActive"
              class="text-[22px] leading-8 text-bw-900 font-normal absolute top-[43%]"
              :class="isNext ? 'left-[13%]' : isPrev ? 'right-[13%]' : ''"
            >
              {{ slide.title }}
            </h3>
          </div>
          <div class="mt-5 text-center" :class="isActive ? '' : 'opacity-50'">
            <div class="flex justify-around md:justify-center mb-5 md:mb-2">
              <button class="md:hidden" @click.stop="slider.slidePrev()">
                <nuxt-icon name="icon-park_arrow-left" filled />
              </button>
              <h3
                v-if="isActive"
                class="text-[22px] leading-normal text-bw-900 font-medium"
              >
                {{ slide.title }}
              </h3>
              <button class="md:hidden" @click.stop="slider.slideNext()">
                <nuxt-icon name="icon-park_arrow-right" filled />
              </button>
            </div>
            <div
              v-if="isActive"
              class="text-base text-bw-800"
              v-html="slide.description"
            ></div>
          </div>
        </SwiperSlide>
      </Swiper>
    </template>
  </section>
</template>

<script setup>
const slider = ref(null)

const onSwiper = swiper => {
  slider.value = swiper
}
const maxSlidesPerView = 2

const isLoading = ref(true)

const officeActivity = ref([])

const getOfficeActivity = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/office-activity`,
    {
      query: {
        'populate[activities][populate][0]': 'icon'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Activities does not exist`
    })
  }

  return data.value
}

const activity = await getOfficeActivity()
officeActivity.value = activity.data

const getActivities = computed(() => {
  const activities = officeActivity?.value?.attributes?.activities || []
  return activities?.length >= maxSlidesPerView * 2
    ? activities
    : [...activities, ...activities]
})
</script>

<style lang="scss" scoped>
:deep(.swiper) {
  button:disabled,
  button[disabled] {
    opacity: 0.4;
  }
}

:deep(.swiper-slide) {
  min-height: 200px;
  height: auto;
  // opacity: 0.5;
  // margin-right: 270px !important;
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;

  img {
    transform: scale(0.8);
    border-radius: 8px;
  }
}

:deep(.swiper-slide-active) {
  opacity: 1;

  img {
    transform: scale(1);
  }
}

:deep(.nuxt-icon) svg {
  width: 2em;
  height: 2em;
}
</style>
